import * as React from "react";
import Layout from "./Layout";
import { Box, Container, Link, Typography } from "@mui/material";
import Results from "./Results";

const RamzovaPage = () => {
    return (
        <Layout>
            <Container maxWidth={"md"}>
                <Typography component="h1" variant="h2">
                    Krásný a těžký výšlap na Šerák
                </Typography>
                <Typography variant={"h4"} component={"h2"} gutterBottom>
                    3. segment - srpen
                </Typography>
                <ul>
                    <li>
                        <Link href={"https://www.strava.com/segments/25023814"}>
                            Segment na webu STRAVA
                        </Link>
                    </li>
                    <li>
                        <Link href={"https://www.relive.cc/view/vrqoMWkAZKO"}>
                            Video ukázka
                        </Link>
                    </li>
                </ul>
                <Typography gutterBottom>
                    V měsíci srpnu nás čeká lázeňská obec Lipová-lázně. Možností
                    potrénovat své tělo bylo od začátku sezony hodně, takže se
                    pustíme do nejnáročnějšího segmentu celého roku. Ano, čeká
                    nás výšlap, výběh na Šerák. Tedy 8,6 km nefalšované dřiny,
                    která je následně odměněna výhledy po celém Mikroregionu
                    Jesenicko. Může to být Vaše jediná účast, nebo naopak již
                    třetí příděl bodů do celkového seriálu. Využijte možnosti si
                    svůj výkon naplánovat v celém měsíci a dobře zvažte
                    oblečení. Jedná se přece jen 840m převýšení:
                </Typography>

                <Box
                    component={"ul"}
                    sx={{ marginTop: (theme) => theme.spacing(2) }}
                >
                    <li>
                        START – pár míst k zaparkování je u obecního úřadu, zde
                        je vhodné se rozcvičit a zahřát tělo. Následně se
                        opatrně podél hlavní cesty přesunete směrem k lázním
                        (dolů) k mostu přes řeku Staříč. Za mostem po odbočení
                        do ulice směřující k Slezkému domu začíná segment
                        u&nbsp;dřevěného sloupu.
                    </li>
                    <li>
                        Pokračujete ulicí dál a vbíháte do areálu Schrothových
                        léčebných lázní. Za Villou Louise vás čeká odbočka
                        doprava a již jste na značené trase – modrá turistická/
                        žlutobílá cyklo. Čeká Vás postupné stoupání krásným
                        údolím až k rozcestí Javořík, kde zabočíte doprava,
                        napojíte se na žlutou turistickou značku. Hned Vás čeká
                        další mírně pravá odbočka a pozor pak hned úzkou cestou
                        vlevo! Cestou se dále dostáváte až k rozcestníku
                        Miroslav, kde pokračujete dále po žluté. Celou dobu je
                        nutné běžet po trase ŽLUTÉ TURISTICKÉ ZNAČKY, někteří
                        nedočkavci občas vymýšlí zkratky, ty však nejsou pro
                        nás, neboť nám by to nezapočítalo segment jako celek a
                        to by po předvedeném výkonu bylo škoda. Více než 12
                        zatáček Vás čeká v strmém kopci, nicméně u rozcestníku
                        Pod Šerákem, kde se napojíme na modrou, již můžete
                        tušit, že k cíli je to už jen kousek!
                    </li>
                    <li>
                        CÍL – poběžíte stále po cestě, kterou příběhnete z
                        „lesa“ budete pokračovat nad chatu Šerák a sprintovat k
                        nejlepšímu času můžete k pomyslné čáře, která je v
                        úrovni rozcestníku – kozoroha.
                    </li>
                </Box>
                <Results segmentId={"3-3-25023814"} />
            </Container>
        </Layout>
    );
};

export default RamzovaPage;
